import React from 'react';
// import Typed from 'react-typed';
import myImage from './../assets/image.png';
import { AiFillLinkedin, AiFillGithub, AiFillMail } from 'react-icons/ai';
import { FaPhoneAlt, FaFileDownload } from 'react-icons/fa';
import { HiDocumentText } from 'react-icons/hi';
import Typewriter from './Typewriter';
import { useTranslation } from 'react-i18next';

function Main() {
    const { t } = useTranslation();
    
    return (
        <div id="main" className="flex flex-col sm:min-h-0 min-h-[calc(100vh-6.4rem)] pl-[3rem] pt-24 lg:pt-28 lg:m-16 lg:pb-0 pr-[1rem] py-[0rem] md:pt-24 tm:flex-col sm:flex-row sm:px-[1.5rem] sm:pt-24">
            <div className="flex flex-col sm:flex-row sm:items-center pt-0 justify-center w-full min-h-[58vh] tm:min-h-min tm:w-full sm:min-h-min sm:w-full sm:pt-0 tm:pt-0">
                <div className="flex flex-col justify-center sm:w-[70%] w-full sm:mr-5">
                    <h1 className="font-[400] text-[2rem] md:text-[1.7rem] tm:text-[2rem] sm:text-[1.6rem]">
                        {t('main.hi')}
                    </h1>
                    <blockquote className="font-[800] text-[2rem] text-[#ec6e59;] mt-[-10px] lg:text-[2.4rem] md:text-[2rem] tm:text-[2.5rem] sm:text-[1rem]">
                        {t('main.im')}
                        <span className="before:block mx-4 mb-6 mt-4 before:absolute before:-inset-2 before:-skew-y-[3deg] before:bg-[#ec6e59;] relative inline-block">
                            <span className="relative text-[#fffffff0] dark:text-[#20262E]"> Rami Alaeddine</span>
                        </span>
                    </blockquote>
                    <div className="h-10 mt-4">
                        <Typewriter />
                    </div>
                    <p className="dark:text-[#ccc] text-justify leading-loose pt-5 font-[400] mt-[-.8rem] text-custom-18 sm:text-[1rem] w-[90%] md:w-[95%] tm:w-full sm:w-full sm:mt-0">
                    {t('main.description')}
                    </p>
                    
                    {/* Resume Button */}
                    <div className="mt-6">
                        <a 
                            href="/resume.pdf" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-[#ec6e59] text-white font-semibold rounded-lg hover:bg-[#d95d4a] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                        >
                            <HiDocumentText size={24} />
                            <span>{t('main.viewResume') || 'View Resume'}</span>
                            <FaFileDownload size={20} />
                        </a>
                    </div>
                    
                </div>
                <div className="flex py-[10px] tm:mt-[40px] items-start mt-[-30px] tm:pr-0 sm:pr-0 sm:justify-between sm:flex-col">
                    <div className="box" >
                        <div className="h-full justify-end flex items-center sm:justify-center">
                            <img
                                src={myImage}
                                alt="main"
                                className="h-[80%] min-h-[100px] min-w-[100px] tm:h-[36px] tm:mt-[200px] sm:min-h-[100px] sm:min-w-[100px] sm:mr-[100px] sm:ml-[50px]"
                            />
                        </div>


                    </div>

                    
                </div>
                <div className="flex place-content-center mt-7 ">
                        <div className="flex flex-row sm:flex-col gap-4">
                            <div className="relative group">
                                <a rel="noreferrer" href="https://www.linkedin.com/in/alaeddine-rami-bbb9a52a6/" target="_blank">
                                    <AiFillLinkedin size={40} className="cursor-pointer hover:text-[#ec6e59] transition-colors" />
                                </a>
                                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-48 max-h-0 overflow-hidden group-hover:max-h-40 transition-all duration-500 ease-in-out">
                                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 border border-gray-200 dark:border-gray-700">
                                        <p className="text-sm text-gray-700 dark:text-gray-300 font-medium">LinkedIn Profile</p>
                                    </div>
                                </div>
                            </div>
                            <div className="relative group">
                                <a rel="noreferrer" href="https://github.com/alaeddinerami" target="_blank">
                                    <AiFillGithub size={40} className="cursor-pointer hover:text-[#ec6e59] transition-colors" />
                                </a>
                                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-48 max-h-0 overflow-hidden group-hover:max-h-40 transition-all duration-500 ease-in-out">
                                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 border border-gray-200 dark:border-gray-700">
                                        <p className="text-sm text-gray-700 dark:text-gray-300 font-medium">GitHub Profile</p>
                                    </div>
                                </div>
                            </div>
                            <div className="relative group">
                                <a rel="noreferrer" href="mailto:alaeddinerami7@gmail.com" target="_blank">
                                    <AiFillMail size={40} className="cursor-pointer hover:text-[#ec6e59] transition-colors" />
                                </a>
                                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-64 max-h-0 overflow-hidden group-hover:max-h-40 transition-all duration-500 ease-in-out z-20">
                                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 border border-gray-200 dark:border-gray-700">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Email</p>
                                        <p className="text-sm text-gray-700 dark:text-gray-300 font-medium break-all">alaeddinerami7@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="relative group">
                                <a rel="noreferrer" href="tel:+212631713538">
                                    <FaPhoneAlt size={36} className="cursor-pointer hover:text-[#ec6e59] transition-colors" />
                                </a>
                                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-48 max-h-0 overflow-hidden group-hover:max-h-40 transition-all duration-500 ease-in-out z-20">
                                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 border border-gray-200 dark:border-gray-700">
                                        <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Phone</p>
                                        <p className="text-sm text-gray-700 dark:text-gray-300 font-medium">+212 631713538</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            
        </div>
    );
}

export default Main;
